import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect x={0.5} y={0.5} width={39} height={39} rx={19.5} fill="#fff" />
        <rect x={0.5} y={0.5} width={39} height={39} rx={19.5} stroke={theme["#B4E3E1"]} />
        <path
            d="M24.166 12.916h-8.333c-2.5 0-4.167 1.25-4.167 4.167v5.834c0 2.916 1.667 4.166 4.167 4.166h8.333c2.5 0 4.167-1.25 4.167-4.166v-5.834c0-2.916-1.667-4.166-4.167-4.166zm-8.958 9.167a.63.63 0 01-.625.625.63.63 0 01-.625-.625v-4.166a.63.63 0 01.625-.626.63.63 0 01.625.625v4.167zm4.791.417a2.497 2.497 0 01-2.5-2.5c0-1.384 1.117-2.5 2.5-2.5 1.384 0 2.5 1.116 2.5 2.5 0 1.383-1.116 2.5-2.5 2.5zm6.042-.417a.63.63 0 01-.625.625.63.63 0 01-.625-.625v-4.166a.63.63 0 01.625-.626.63.63 0 01.625.625v4.167z"
            fill={theme["#0D968F"]}
        />
        </svg>
    )
}
  
  export default SvgComponent